import React, { useEffect } from 'react';
import { Box, Typography, Button, MenuItem } from '@mui/material';
import ProgressBar from '../../../../Shared/ProgressBar';
import { ReactComponent as AdminIcon } from '../../../../../images/icons/assign_user.svg';
import CustomerCareSelect from '../../../../Shared/CustomerCareSelect';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../store';
import { getParentFacilities } from '../../../../../store/facility/actionCreators';
import { dimGrey } from '../../../../../mainTheme';

export const AssignFacilitySelect = ({
  onSelect,
  onBack,
}: {
  onSelect: (facilityId: number) => void;
  onBack: () => void;
}) => {
  const dispatch = useDispatch();

  const [selectedFacility, setSelectedFacility] = React.useState<number | null>(
    null,
  );

  const { parentFacilities, isLoading } = useSelector(
    (state: RootState) => state.facility,
  );

  useEffect(() => {
    if (!parentFacilities || parentFacilities.length === 0) {
      dispatch(getParentFacilities());
    }
  }, [dispatch, parentFacilities]);

  return (
    <Box display="flex" flexDirection="column" gap="24px">
      <ProgressBar currentStep={2} totalSteps={2} />
      <AdminIcon />
      <Box display="flex" flexDirection="column" gap="8px">
        <Typography>Assign admin to a facility</Typography>
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '22px',
            letterSpacing: '0.2px',
            color: dimGrey,
          }}
        >
          Choose an existing facility. To create a new one, go back and select
          facility from the drop down.
        </Typography>
      </Box>

      <CustomerCareSelect
        label="Facility name"
        onChange={(e) => {
          setSelectedFacility(Number(e.target.value));
        }}
        fullWidth
        value={selectedFacility}
        disabled={isLoading}
      >
        {parentFacilities?.map((facility) => (
          <MenuItem
            key={facility.parent_facility_id}
            value={facility.parent_facility_id}
          >
            {facility.parent_facility_name}
          </MenuItem>
        )) ?? []}
      </CustomerCareSelect>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', my: '8px' }}>
        <Button
          variant="text"
          color="secondary"
          onClick={onBack}
          sx={{
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '18px',
            letterSpacing: '0.2px',
            height: '44px',
            width: '180px',
          }}
        >
          Back
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => selectedFacility && onSelect(selectedFacility)}
          disabled={!selectedFacility}
          sx={{
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '18px',
            letterSpacing: '0.2px',
            height: '44px',
            width: '180px',
          }}
        >
          Add
        </Button>
      </Box>
    </Box>
  );
};
